import { render, staticRenderFns } from "./OrganismHero.vue?vue&type=template&id=0d0c41a0&scoped=true&"
import script from "./OrganismHero.vue?vue&type=script&lang=js&"
export * from "./OrganismHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c41a0",
  null
  
)

export default component.exports